// import '../styles/main.scss';
import 'lazysizes';

import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
import collapse from '@alpinejs/collapse'

// Import Swiper
import Swiper from 'swiper';
// import 'swiper/swiper-bundle.css';
import { Navigation, Pagination, Thumbs, Mousewheel } from 'swiper/modules';

// import '../components/alp-main-store';
// import '../components/alp-cart';
// import '../components/alp-build-box'; // FE TODO Must be included only for the build box section

window.Alpine = Alpine;
window.Swiper = Swiper;
Swiper.use([Navigation, Pagination, Thumbs, Mousewheel]);

Alpine.plugin(persist);
Alpine.plugin(collapse);
Alpine.start();

document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
        e.target.removeAttribute('data-bg');
    }
}, false);

// import { variantSelect } from '../components/variant-select';
// import { headerSticky } from '../components/header';

// headerSticky();
// variantSelect();

if (window.innerWidth < 768) {
    let lastScrollTop = 0;
    const header = document.querySelector(".header-wrapper");

    window.addEventListener("scroll", () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const halfScreenHeight = window.innerHeight / 2;
    
        if (scrollTop > halfScreenHeight) {
          if (scrollTop > lastScrollTop) {
            header.classList.add("scroll-up");
          } else {
            header.classList.remove("scroll-up");
          }
        } else {
          
          header.classList.remove("scroll-up");
        }
    
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });
}

// window.addEventListener('load', () => {
//     const ratingItems = document.querySelectorAll('.product-card__rating');

//     ratingItems.forEach(item => {
//         console.log(item.shadowRoot);
//         if (item.shadowRoot) {
//             const shadow = item.shadowRoot;
//             const emptyStar = shadow.querySelectorAll('.gw-rv-avg-rating__star-empty');

//             console.log(emptyStar);
//           }
//     });
// });